import React from 'react';
import Calendar from 'react-calendar';
import { format, isSameDay } from 'date-fns';

interface JournalCalendarProps {
  entries: any[];
  selectedDate: Date;
  onDateSelect: (date: Date) => void;
}

export function JournalCalendar({ entries, selectedDate, onDateSelect }: JournalCalendarProps) {
  const tileClassName = ({ date }: { date: Date }) => {
    const entry = entries?.find(entry => 
      isSameDay(new Date(entry.date), date)
    );
    
    if (!entry) return '';
    
    let classes = 'has-entry';
    
    // Add color class based on day rating
    if (entry.day_rating >= 7) {
      classes += ' bg-green-50 hover:bg-green-100';
    } else if (entry.day_rating >= 4) {
      classes += ' bg-yellow-50 hover:bg-yellow-100';
    } else if (entry.day_rating > 0) {
      classes += ' bg-red-50 hover:bg-red-100';
    }
    
    return classes;
  };

  const tileContent = ({ date }: { date: Date }) => {
    const entry = entries?.find(entry => 
      isSameDay(new Date(entry.date), date)
    );
    
    if (!entry) return null;
    
    return (
      <div className="flex flex-col items-center justify-center gap-1">
        <div className={`w-2 h-2 rounded-full ${
          entry.day_rating >= 7
            ? 'bg-green-400'
            : entry.day_rating >= 4
            ? 'bg-yellow-400'
            : entry.day_rating > 0
            ? 'bg-red-400'
            : 'bg-gray-300'
        }`} />
        {entry.tasks?.length > 0 && (
          <div className="text-xs text-gray-500">
            {entry.tasks.filter((t: any) => t.completed).length}/{entry.tasks.length}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="p-6 bg-white rounded-[30px] shadow-xl">
      <Calendar
        value={selectedDate}
        onChange={onDateSelect}
        tileClassName={tileClassName}
        tileContent={tileContent}
        className="w-full border-none"
        minDetail="month"
        maxDetail="month"
        showNeighboringMonth={false}
        formatShortWeekday={(locale, date) => 
          format(date, 'EEE').toUpperCase()
        }
        formatMonth={(locale, date) => 
          format(date, 'MMMM yyyy')
        }
        navigationLabel={({ date }) => 
          format(date, 'MMMM yyyy')
        }
      />
    </div>
  );
}